import classNames from 'classnames';
import type { FocusEventHandler } from 'react';

export interface InputBoxProps {
  state?: 'normal' | 'error';
  onFocus?: FocusEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}

export const InputBox = ({ state, onFocus, children }: InputBoxProps) => {
  return (
    <div
      className={classNames(
        'rounded-md outline focus:outline focus-within:outline outline-1 overflow-hidden',
        state === 'error'
          ? 'outline-ds-danger-400'
          : 'outline-ds-natural-150 focus:outline-ds-primary-300 focus-within:outline-ds-primary-300'
      )}
      onFocus={onFocus}
    >
      {children}
    </div>
  );
};
